module.exports = __webpack_public_path__ + "img/cjcl6.0eb18813.png";